import Layout from '@layout/Index'

export const launchPageActivity = [
  {
    path: '/launch-page-activity',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "launch-page-activity-table" */ './pages/LaunchPageActivityTable.vue'),
        name: '登录页图片',
        meta: {
          title: '登录页图片',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "launch-page-activity-form" */ './pages/LaunchPageActivityForm.vue'),
        name: '添加活动',
        meta: {
          title: '添加活动',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "launch-page-activity-form" */ './pages/LaunchPageActivityForm.vue'),
        name: '修改活动',
        meta: {
          title: '修改活动',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "launch-page-activity-detail" */ './pages/LaunchPageActivityDetail.vue'),
        name: '活动详情',
        meta: {
          title: '活动详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/launch-page-activity/launch-page-activity.route.js